import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import { BalanceProvider } from '@/contexts/BalanceContext'
import { SSEProvider } from '@/contexts/SSEContext'
import { CountryBlockingProvider } from '@/contexts/CountryBlockingContext'
import { Layout } from '@/components/Layout'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { Suspense } from 'react'
import LoadingScreen from './components/Loading'
import { lazy } from 'react'
import { usePageTracking } from './hooks/usePageTracking'
import { useUtmTracking } from './hooks/useUtmTracking'

const Home = lazy(() => import('@/pages/Home').then(module => ({ default: module.Home })))
const RoomDetail = lazy(() => import('@/pages/RoomDetail').then(module => ({ default: module.RoomDetail })))
const Profile = lazy(() => import('@/pages/Profile').then(module => ({ default: module.Profile })))
const Admin = lazy(() => import('@/pages/Admin').then(module => ({ default: module.Admin })))
const Login = lazy(() => import('@/pages/Login').then(module => ({ default: module.Login })))
const Register = lazy(() => import('@/pages/Register').then(module => ({ default: module.Register })))
const EmailVerification = lazy(() => import('@/pages/EmailVerification').then(module => ({ default: module.EmailVerification })))
const ForgotPassword = lazy(() => import('@/pages/ForgotPassword').then(module => ({ default: module.ForgotPassword })))
const ResetPassword = lazy(() => import('@/pages/ResetPassword').then(module => ({ default: module.ResetPassword })))
const Deposit = lazy(() => import('@/pages/Deposit').then(module => ({ default: module.Deposit })))
const Withdraw = lazy(() => import('@/pages/Withdraw').then(module => ({ default: module.Withdraw })))
const HowItWorks = lazy(() => import('@/pages/HowItWorks').then(module => ({ default: module.HowItWorks })))

function App() {
  usePageTracking();
  useUtmTracking();

  return (
    <CountryBlockingProvider>
      <AuthProvider>
        <SSEProvider>
          <BalanceProvider>
            <Layout>
              <Suspense fallback={<LoadingScreen />}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/how-it-works" element={<HowItWorks />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/verify-email" element={<EmailVerification />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/rooms/:id" element={<RoomDetail />} />
                  <Route
                    path="/me"
                    element={
                      <ProtectedRoute>
                        <Profile />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/deposit"
                    element={
                      <ProtectedRoute>
                        <Deposit />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/withdraw"
                    element={
                      <ProtectedRoute>
                        <Withdraw />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin"
                    element={
                      <ProtectedRoute requireAdmin>
                        <Admin />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </Suspense>
            </Layout>
          </BalanceProvider>
        </SSEProvider>
      </AuthProvider>
    </CountryBlockingProvider >
  )
}

export default App 